import FlatFilterSection from './FlatFilterSection';

export default FlatFilterSection;
